import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { dataTableSectionSx } from "common/Components/DataTable/DataTable.styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";

export const userAccessDrawerPaperSx = {
  width: "min(760px, 100vw)",
};

export const PageContainer = styled(Box)({
  ...dataTableSectionSx,
  fontFamily: appThemeFonts.family.ui,
});

export const PageInviteButton = styled(Button)(() => ({
  height: "38px",
  padding: "0 18px",
  backgroundColor: appThemeColors.text.lightBlue,
  borderRadius: "9999px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: appThemeFonts.family.ui,
  fontSize: "13.5px",
  fontWeight: 600,
  color: appThemeColors.neutral.white,
  gap: "8px",
  "& .MuiButton-startIcon": {
    margin: 0,
    "& > *:nth-of-type(1)": {
      fontSize: 16,
    },
  },
  "&:hover": {
    boxShadow: "none",
    backgroundColor: appThemeColors.text.heading,
  },
  "&:focus-visible": {
    outline: "2px solid #0B5FA5",
    outlineOffset: "2px",
  },
}));

export const ErrorAlertContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
